module.exports = __webpack_public_path__ + "img/dark_box2_tag1.59345ce0.png";